<template>
  <div v-if="totalsData && totalsData.customerFinancialReportDTO" class="row mr-0">
    <div class="col-lg-1 col-0"></div>

     <div class="col-lg-2 col-md-6 col-12 mt-4 d-flex align-items-stretch">
      <div class="card text-center p-1 w-100 h-100 d-flex flex-column justify-content-center mr-2 ml-2" style="border:1px solid #ddd;">
        <div class="text-uppercase text-secondary" title="(Factures - Avoirs) ouvert + (BL - Retour) non facturés">En Cours Commercial</div>
        <h4 class="text-primary font-weight-normal pt-2 font-size-18">
          {{ totalsData.customerFinancialReportDTO.currentAccountBalanceStr || '-' }}
        </h4>
      </div>
    </div>

    <div class="col-lg-2 col-md-6 col-12 mt-4 d-flex align-items-stretch" >
      <div class="card text-center p-1 w-100 h-100 d-flex flex-column justify-content-center mr-2" style="border:1px solid #ddd;">
        <div class="text-uppercase text-secondary" @click="openDocumentsModal(DOCUMENT_TYPE.RETURN_RECEIPT_AND_SALES_SHIPMENT)" style="cursor: pointer;">
          BL & retours non facturés
          <i class="fas fa-info-circle font-size-14 font-weight-bold align-middle text-info ml-2" ></i>
        </div>
        <h4 class="text-primary font-weight-normal pt-2 font-size-18">
          {{ totalsData.customerFinancialReportDTO.deliveredAndReturnNotInvoiced != null ? totalsData.customerFinancialReportDTO.deliveredAndReturnNotInvoiced : '-' }}

        </h4>
      </div>
    </div>

    <div class="col-lg-2 col-md-6 col-12 mt-4 d-flex align-items-stretch">
      <div class="card text-center p-1 w-100 h-100 d-flex flex-column justify-content-center mr-2 ml-2" style="border:1px solid #ddd;">
        <div class="text-uppercase text-secondary"  @click="openDocumentsModal(DOCUMENT_TYPE.INVOICE_AND_CREDIT_MEMO)"  style="cursor: pointer;">
          Factures et Avoirs non réglés
          <i class="fas fa-info-circle  font-size-14  font-weight-bold text-info align-middle ml-2"></i>
        </div>
        <h4 class="text-primary font-weight-normal pt-2 font-size-18">
          {{ totalsData.customerFinancialReportDTO.unpaidInvoiceMinusCreditNote != null ? totalsData.customerFinancialReportDTO.unpaidInvoiceMinusCreditNote : '-' }}

        </h4>
      </div>
    </div>

    <div class="col-lg-2 col-md-6 col-12 mt-4 d-flex align-items-stretch">
      <div class="card text-center p-1 w-100 h-100 d-flex flex-column justify-content-center mr-2 ml-2" style="border:1px solid #ddd;">
        <div class="text-uppercase text-secondary" @click="openDocumentsModal(DOCUMENT_TYPE.TRAITE_CHEQUE)" style="cursor: pointer;" title="Traites + chèques en coffre">
          En Cours Financier
          <i class="fas fa-info-circle font-size-14 font-weight-bold text-info align-middle ml-2"></i>
        </div>
        <h4 class="text-primary font-weight-normal pt-2 font-size-18">
          {{ totalsData.customerFinancialReportDTO.billAndChequeInSafe != null ? totalsData.customerFinancialReportDTO.billAndChequeInSafe : '-' }}
        </h4>
      </div>
    </div>

    <div class="col-lg-2 col-md-6 col-12 mt-4 d-flex align-items-stretch">
      <div class="card text-center p-1 w-100 h-100 d-flex flex-column justify-content-center ml-2" style="border:1px solid #ddd;">
        <div class="text-uppercase font-weight-bold text-secondary">Solde Général</div>
        <h4 class="text-primary font-weight-bold pt-2 font-size-18">
          {{ totalsData.customerFinancialReportDTO.globalSoldeStr || '-' }}
        </h4>
      </div>
    </div>


      <b-modal v-if="showDocumentsModal"
        v-model="showDocumentsModal"
        centered 
        hide-footer
        hide-header
        size="lg">

            <div class="row mb-1 mt-0">
              <span class="font-size-16 font-weight-bold text-primary">
                Liste des  {{
                  selectedDocumentType === DOCUMENT_TYPE.INVOICE
                    ? 'Factures non réglées'
                    : selectedDocumentType === DOCUMENT_TYPE.CREDIT_MEMO
                      ? 'Avoirs non réglés'
                      : selectedDocumentType === DOCUMENT_TYPE.INVOICE_AND_CREDIT_MEMO
                        ? 'Factures et Avoirs non réglés'
                        : selectedDocumentType === DOCUMENT_TYPE.RETURN_RECEIPT_AND_SALES_SHIPMENT
                          ? 'BL & retours non facturés'
                          : selectedDocumentType === DOCUMENT_TYPE.TRAITE_CHEQUE
                            ? 'Traites et chèques'
                      : ''}}
              </span>
            </div>

          <div class="table-responsive mb-0 mt-3" style="min-height:20em;">
            <template v-if="selectedDocumentType === DOCUMENT_TYPE.INVOICE_AND_CREDIT_MEMO">
            <div class="font-weight-bold text-primary mb-2">Factures non réglées</div>
            <b-table
            :busy="false"
            :striped="true"
            :small="true"
            :hover="true"
            :items="invoiceDocumentList"
            :fields="documentFields"
            :per-page="pagination.invoice.perPage"
            :current-page="pagination.invoice.currentPage"
            thead-style="display: none"
            >
            <template v-slot:table-busy>
            <div class="text-center my-2">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
            </template>

            <template v-slot:head(EntryNo)>
              {{ $t("reporting.customer.financial.fields.entryNo") }}
            </template>

            <template v-slot:head(PostingDate)>
              {{ $t("reporting.customer.financial.fields.postingDate") }}
            </template>

            <template v-slot:head(DueDate)>
              {{ $t("reporting.customer.financial.fields.dueDate") }}
            </template>

            <template v-slot:head(shipmentDate)>
              {{ $t("reporting.customer.financial.fields.shipmentDate") }}
            </template>

            <template v-slot:head(DocumentNo)>
              {{ $t("reporting.customer.financial.fields.documentNo") }}
            </template>

            <template v-slot:head(amountStr)>
              {{ $t("reporting.customer.financial.fields.amount") }}
            </template>

            <template v-slot:head(remainingAmountStr)>
              {{ $t("reporting.customer.financial.fields.remainingAmount") }}
            </template>
            </b-table>
            <div class="row pt-3 pl-2 mb-sm-4">
              <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                  <b-form-select @input="onPerPageChange('invoice')" v-model="pagination.invoice.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                  <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{ pagination.invoice.totalRows }} {{ $t("pagination.lines") }}</span></div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagination.invoice.currentPage" :per-page="pagination.invoice.perPage" :total-rows="pagination.invoice.totalRows" :disabled="isGetDocumentsStarting"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <span v-if="!isGetDocumentsStarting && !invoiceDocumentList.length" class="d-flex justify-content-center m-2 text-danger" >{{$t("reporting.supplier.emptyTable") }} </span>

            <div class="font-weight-bold text-primary mt-4 mb-2">Avoirs non réglés</div>
            <b-table
            :busy="false"
            :striped="true"
            :small="true"
            :hover="true"
            :items="creditMemoDocumentList"
            :fields="documentFields"
            :per-page="pagination.creditMemo.perPage"
            :current-page="pagination.creditMemo.currentPage"
            thead-style="display: none"
            >
            <template v-slot:table-busy>
            <div class="text-center my-2">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
            </template>

            <template v-slot:head(EntryNo)>
              {{ $t("reporting.customer.financial.fields.entryNo") }}
            </template>

            <template v-slot:head(PostingDate)>
              {{ $t("reporting.customer.financial.fields.postingDate") }}
            </template>

            <template v-slot:head(DueDate)>
              {{ $t("reporting.customer.financial.fields.dueDate") }}
            </template>

            <template v-slot:head(shipmentDate)>
              Shipment Date
            </template>

            <template v-slot:head(DocumentNo)>
              {{ $t("reporting.customer.financial.fields.documentNo") }}
            </template>

            <template v-slot:head(amountStr)>
              {{ $t("reporting.customer.financial.fields.amount") }}
            </template>

            <template v-slot:head(remainingAmountStr)>
              {{ $t("reporting.customer.financial.fields.remainingAmount") }}
            </template>
            </b-table>
            <div class="row pt-3 pl-2 mb-sm-4">
              <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                  <b-form-select @input="onPerPageChange('creditMemo')" v-model="pagination.creditMemo.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                  <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{ pagination.creditMemo.totalRows }} {{ $t("pagination.lines") }}</span></div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagination.creditMemo.currentPage" :per-page="pagination.creditMemo.perPage" :total-rows="pagination.creditMemo.totalRows" :disabled="isGetDocumentsStarting"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <span v-if="!isGetDocumentsStarting && !creditMemoDocumentList.length" class="d-flex justify-content-center m-2 text-danger" >{{$t("reporting.supplier.emptyTable") }} </span>
            </template>

            <template v-else-if="selectedDocumentType === DOCUMENT_TYPE.RETURN_RECEIPT_AND_SALES_SHIPMENT">
            <div class="font-weight-bold text-primary mb-2">BL non facturés</div>
            <b-table
            :busy="false"
            :striped="true"
            :small="true"
            :hover="true"
            :items="salesShipmentDocumentList"
            :fields="documentFields"
            :per-page="pagination.salesShipment.perPage"
            :current-page="pagination.salesShipment.currentPage"
            thead-style="display: none"
            >
            <template v-slot:table-busy>
            <div class="text-center my-2">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
            </template>

            <template v-slot:head(EntryNo)>
              {{ $t("reporting.customer.financial.fields.entryNo") }}
            </template>

            <template v-slot:head(PostingDate)>
              {{ $t("reporting.customer.financial.fields.postingDate") }}
            </template>

            <template v-slot:head(DueDate)>
              {{ $t("reporting.customer.financial.fields.dueDate") }}
            </template>

            <template v-slot:head(shipmentDate)>
              {{ $t("reporting.customer.financial.fields.shipmentDate") }}
            </template>


            <template v-slot:head(DocumentNo)>
              {{ $t("reporting.customer.financial.fields.documentNo") }}
            </template>

            <template v-slot:head(amountStr)>
              {{ $t("reporting.customer.financial.fields.amount") }}
            </template>

            <template v-slot:head(remainingAmountStr)>
              {{ $t("reporting.customer.financial.fields.remainingAmount") }}
            </template>
            </b-table>
            <div class="row pt-3 pl-2 mb-sm-4">
              <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                  <b-form-select @input="onPerPageChange('salesShipment')" v-model="pagination.salesShipment.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                  <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{ pagination.salesShipment.totalRows }} {{ $t("pagination.lines") }}</span></div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagination.salesShipment.currentPage" :per-page="pagination.salesShipment.perPage" :total-rows="pagination.salesShipment.totalRows" :disabled="isGetDocumentsStarting"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <span v-if="!isGetDocumentsStarting && !salesShipmentDocumentList.length" class="d-flex justify-content-center m-2 text-danger" >{{$t("reporting.supplier.emptyTable") }} </span>

            <div class="font-weight-bold text-primary mt-4 mb-2">Retours non facturés</div>
            <b-table
            :busy="false"
            :striped="true"
            :small="true"
            :hover="true"
            :items="returnReceiptDocumentList"
            :fields="documentFields"
            :per-page="pagination.returnReceipt.perPage"
            :current-page="pagination.returnReceipt.currentPage"
            thead-style="display: none"
            >
            <template v-slot:table-busy>
            <div class="text-center my-2">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
            </template>

            <template v-slot:head(EntryNo)>
              {{ $t("reporting.customer.financial.fields.entryNo") }}
            </template>

            <template v-slot:head(PostingDate)>
              {{ $t("reporting.customer.financial.fields.postingDate") }}
            </template>

            <template v-slot:head(DueDate)>
              {{ $t("reporting.customer.financial.fields.dueDate") }}
            </template>

            <template v-slot:head(shipmentDate)>
              {{ $t("reporting.customer.financial.fields.shipmentDate") }}
            </template>

            <template v-slot:head(DocumentNo)>
              {{ $t("reporting.customer.financial.fields.documentNo") }}
            </template>

            <template v-slot:head(amountStr)>
              {{ $t("reporting.customer.financial.fields.amount") }}
            </template>

            <template v-slot:head(remainingAmountStr)>
              {{ $t("reporting.customer.financial.fields.remainingAmount") }}
            </template>
            </b-table>
            <div class="row pt-3 pl-2 mb-sm-4">
              <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                  <b-form-select @input="onPerPageChange('returnReceipt')" v-model="pagination.returnReceipt.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                  <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{ pagination.returnReceipt.totalRows }} {{ $t("pagination.lines") }}</span></div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagination.returnReceipt.currentPage" :per-page="pagination.returnReceipt.perPage" :total-rows="pagination.returnReceipt.totalRows" :disabled="isGetDocumentsStarting"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <span v-if="!isGetDocumentsStarting && !returnReceiptDocumentList.length" class="d-flex justify-content-center m-2 text-danger" >{{$t("reporting.supplier.emptyTable") }} </span>
            </template>

            <template v-else>
            <b-table
            :busy="false"
            :striped="true"
            :small="true"
            :hover="true"
            :items="documentList"
            :fields="documentFields"
            :per-page="pagination.document.perPage"
            :current-page="pagination.document.currentPage"
            thead-style="display: none"
            >
            <template v-slot:table-busy>
            <div class="text-center my-2">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
            </template>

            <template v-slot:head(EntryNo)>
              {{ $t("reporting.customer.financial.fields.entryNo") }}
            </template>

            <template v-slot:head(PostingDate)>
              {{ $t("reporting.customer.financial.fields.postingDate") }}
            </template>

            <template v-slot:head(DueDate)>
              {{ $t("reporting.customer.financial.fields.dueDate") }}
            </template>

            <template v-slot:head(shipmentDate)>
              {{ $t("reporting.customer.financial.fields.shipmentDate") }}
            </template>

            <template v-slot:head(DocumentNo)>
              {{ $t("reporting.customer.financial.fields.documentNo") }}
            </template>

            <template v-slot:head(amountStr)>
              {{ $t("reporting.customer.financial.fields.amount") }}
            </template>

            <template v-slot:head(remainingAmountStr)>
              {{ $t("reporting.customer.financial.fields.remainingAmount") }}
            </template>


         

            </b-table>
            <div class="row pt-3 pl-2 mb-sm-4">
              <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                  <b-form-select @input="onPerPageChange('document')" v-model="pagination.document.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                  <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{ pagination.document.totalRows }} {{ $t("pagination.lines") }}</span></div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagination.document.currentPage" :per-page="pagination.document.perPage" :total-rows="pagination.document.totalRows" :disabled="isGetDocumentsStarting"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <span v-if="!isGetDocumentsStarting && !documentList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("reporting.supplier.emptyTable") }} </span>
      </template>
        </div>

    </b-modal>


  </div>
</template>

  
  <script>
  import Vue from 'vue';
  import VueApexCharts from 'vue-apexcharts';
  import ExtDocumentAPI from "@/services/ext-document-api";

  Vue.component('apexchart', VueApexCharts);
  
  export default {

    props: {
      totalsData: {
            type: Object,
            default: () => null,
          },
    },

    data() {
      return {

        DOCUMENT_TYPE: {
          INVOICE: 'Invoice',
          CREDIT_MEMO: 'Credit Memo',
          INVOICE_AND_CREDIT_MEMO: 'InvoiceAndCreditMemo',
          RETURN_RECEIPT: 'returnReceiptAPI',
          SALES_SHIPMENT: 'salesShipmentAPI',
          RETURN_RECEIPT_AND_SALES_SHIPMENT: 'returnReceiptAndSalesShipment',
          TRAITE_CHEQUE: 'traiteCheque'
        },

        fields: [
          { key: "DocumentNo", label: "", tdClass: "text-center font-weight-bold", thClass: "text-center", tdStyle: "min-width: 140px;", thStyle: "min-width: 140px;" },
          { key: "PostingDate", label: "", tdClass: "text-center", thClass: "text-center", tdStyle: "min-width: 120px;", thStyle: "min-width: 120px;" },
          { key: "DueDate", label: "", tdClass: "text-center", thClass: "text-center", tdStyle: "min-width: 120px;", thStyle: "min-width: 120px;" },
          { key: "amountStr", label: "", tdClass: "text-right", thClass: "text-right", tdStyle: "min-width: 130px;", thStyle: "min-width: 130px;" },
          { key: "remainingAmountStr", label: "", tdClass: "text-right", thClass: "text-right", tdStyle: "min-width: 150px;", thStyle: "min-width: 150px;" }
        ],

        series1: [
          {  data: [53, 68, 75, 120, 85, 102, 43] },
        ],
        series2: [
          {  data: [40, 60, 70, 85, 73, 90, 43] },
        ],
        series3: [
          { data: [32, 44, 61, 77, 55, 80, 47] },
        ],
        chartOptions1: {},
        chartOptions2: {},
        chartOptions3: {},
        documentList:[],
        invoiceDocumentList:[],
        creditMemoDocumentList:[],
        returnReceiptDocumentList:[],
        salesShipmentDocumentList:[],
        showDocumentsModal: false,
        isGetDocumentsStarting: false,
        selectedDocumentType: null,
        pagination: {
          document: { currentPage: 1, perPage: 10, totalRows: 0 },
          invoice: { currentPage: 1, perPage: 10, totalRows: 0 },
          creditMemo: { currentPage: 1, perPage: 10, totalRows: 0 },
          returnReceipt: { currentPage: 1, perPage: 10, totalRows: 0 },
          salesShipment: { currentPage: 1, perPage: 10, totalRows: 0 },
        },
        pagemodel: {currentPage : 1, perPage : 100, totalRows: 0},

      };
    },
    mounted() {
      this.renderSparkline1();
      this.renderSparkline2();
      this.renderSparkline3();
    },
    computed: {
      documentFields() {
        if (this.selectedDocumentType === this.DOCUMENT_TYPE.RETURN_RECEIPT_AND_SALES_SHIPMENT) {
          return this.fields.map(field => {
            if (field.key === "DueDate") {
              return { ...field, key: "shipmentDate" };
            }
            return field;
          });
        }
        return this.fields;
      }
    },
    methods: {

      onPerPageChange(type) {
        if (this.pagination[type]) {
          this.pagination[type].currentPage = 1;
        }
      },

      openDocumentsModal(type){
        this.selectedDocumentType = type;
        this.getDocuments();
        this.showDocumentsModal = true;
      },

      getDocuments() {
        this.pagination.document.currentPage = 1;
        this.pagination.invoice.currentPage = 1;
        this.pagination.creditMemo.currentPage = 1;
        this.pagination.returnReceipt.currentPage = 1;
        this.pagination.salesShipment.currentPage = 1;
        this.pagination.document.totalRows = 0;
        this.pagination.invoice.totalRows = 0;
        this.pagination.creditMemo.totalRows = 0;
        this.pagination.returnReceipt.totalRows = 0;
        this.pagination.salesShipment.totalRows = 0;
        this.documentList=[];
        this.invoiceDocumentList=[];
        this.creditMemoDocumentList=[];
        this.returnReceiptDocumentList=[];
        this.salesShipmentDocumentList=[];
        this.isGetDocumentsStarting = true;
        if (this.selectedDocumentType === this.DOCUMENT_TYPE.INVOICE_AND_CREDIT_MEMO) {
          Promise.all([
            ExtDocumentAPI.getDocumentsByType(this.pagemodel.currentPage, this.pagemodel.perPage, this.DOCUMENT_TYPE.INVOICE, null, null),
            ExtDocumentAPI.getDocumentsByType(this.pagemodel.currentPage, this.pagemodel.perPage, this.DOCUMENT_TYPE.CREDIT_MEMO, null, null)
          ]).then(([invoiceResponse, creditMemoResponse]) => {
            this.invoiceDocumentList = invoiceResponse && invoiceResponse.lines ? invoiceResponse.lines : [];
            this.creditMemoDocumentList = creditMemoResponse && creditMemoResponse.lines ? creditMemoResponse.lines : [];
            this.pagination.invoice.totalRows = this.invoiceDocumentList.length;
            this.pagination.creditMemo.totalRows = this.creditMemoDocumentList.length;
          }).finally(() => {
            this.isGetDocumentsStarting = false;
          });
          return;
        }

        if (this.selectedDocumentType === this.DOCUMENT_TYPE.RETURN_RECEIPT_AND_SALES_SHIPMENT) {
          Promise.all([
            ExtDocumentAPI.getDocumentsByType(this.pagemodel.currentPage, this.pagemodel.perPage, this.DOCUMENT_TYPE.SALES_SHIPMENT, null, null),
            ExtDocumentAPI.getDocumentsByType(this.pagemodel.currentPage, this.pagemodel.perPage, this.DOCUMENT_TYPE.RETURN_RECEIPT, null, null)
          ]).then(([salesShipmentResponse, returnReceiptResponse]) => {
            this.salesShipmentDocumentList = salesShipmentResponse && salesShipmentResponse.lines ? salesShipmentResponse.lines : [];
            this.returnReceiptDocumentList = returnReceiptResponse && returnReceiptResponse.lines ? returnReceiptResponse.lines : [];
            this.pagination.salesShipment.totalRows = this.salesShipmentDocumentList.length;
            this.pagination.returnReceipt.totalRows = this.returnReceiptDocumentList.length;
          }).finally(() => {
            this.isGetDocumentsStarting = false;
          });
          return;
        }

        if (this.selectedDocumentType === this.DOCUMENT_TYPE.TRAITE_CHEQUE) {
          ExtDocumentAPI.getTraiteChequeByDocumentAndCustomer(this.pagemodel.currentPage, this.pagemodel.perPage, null).then(response => {
            if (response) {
              this.documentList = response.lines ? response.lines : [];
              this.pagination.document.totalRows = this.documentList.length;
            }
          }).finally(() => {
            this.isGetDocumentsStarting = false;
          });
          return;
        }

        ExtDocumentAPI.getDocumentsByType(this.pagemodel.currentPage, this.pagemodel.perPage, this.selectedDocumentType, null, null).then(response => {
          if (response) {
            this.documentList = response.lines;
            this.pagination.document.totalRows = this.documentList.length;
          }
        }).finally(() => {
          this.isGetDocumentsStarting = false;
        });
      },

      formatNumber(num) {
        return num.toLocaleString();
      },
      renderSparkline1() {
        this.chartOptions1 = this.getSparklineOptions();
      },
      renderSparkline2() {
        this.chartOptions2 = this.getSparklineOptions();
      },
      renderSparkline3() {
        this.chartOptions3 = this.getSparklineOptions();
      },
      getSparklineOptions() {
  return {
    chart: {
      type: 'line',
      height: 100,
      sparkline: { enabled: true },
      toolbar: {
        show: false, 
      }
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    tooltip: {
      enabled: true,
    },
    xaxis: {
      type: 'datetime',
      categories: [
        '2024-09-12',
        '2024-09-13',
        '2024-09-14',
        '2024-09-15',
        '2024-09-16',
        '2024-09-17',
        '2024-09-18',
      ],
      tooltip: {
        enabled: false,
      },
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: false,
    }
  };
}

    },
  };
  </script>
  
  <style scoped>
  .card {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    text-align: center;
  }
  
  h4 {
    font-size: 1.5rem;
    font-weight: bold;
  }
  
  p {
    font-size: 0.9rem;
    color: #6c757d;
  }
  </style>
  